import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { HardwareBackButton } from '@core/services/common';
import { Moment } from 'moment';
import { Subscription } from 'rxjs';
import { ContextService } from '../../../core/services/core/context.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html'
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input() i18 = '';
  @Input() initValue = '';
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Output() date = new EventEmitter<{ value: Moment }>();
  @ViewChild('picker', { static: false }) picker: MatDatepicker<Moment>;

  mustCloseSubscription: Subscription;

  constructor(
    public ctx: ContextService,
    private hardwareBackButton: HardwareBackButton
  ) {}

  onSelectDate(event) {
    if (!event.value) {
      return;
    }
    this.date.emit(event);
  }

  ngOnInit() {
    this.hardwareBackButton.closeBeforeNavBack$.subscribe(layer => {
      if (layer === 'calendar' && this.picker.opened) {
        this.picker.close();
      }
    });
  }

  ngOnDestroy() {
    this.mustCloseSubscription?.unsubscribe();
  }
}
